module.exports = __webpack_public_path__ + "ptc_momoro_M1.850b16ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_M1.jpg
// module id = 65o9
// module chunks = 0